import { Turnstile } from '@marsidev/react-turnstile';
import { Box, Text } from '@mantine/core';
import { TURNSTILE_CONFIG } from '@/config/apiConfig';
import styles from './TurnstileCaptcha.module.css';

/**
 * Cloudflare Turnstile captcha component
 * Invisible/non-intrusive captcha that validates users in the background
 */
export const TurnstileCaptcha = ({
  siteKey,
  onSuccess,
  onError,
  onExpire,
  error
}) => {
  // If Turnstile is disabled, don't render anything
  if (!TURNSTILE_CONFIG.enabled) {
    return null;
  }

  const key = siteKey || TURNSTILE_CONFIG.siteKey;
  const captchaClassName = [styles.turnstileCaptcha, error && styles.turnstileCaptchaError]
    .filter(Boolean)
    .join(' ');

  return (
    <Box className={captchaClassName}>
      <Turnstile
        siteKey={key}
        onSuccess={onSuccess}
        onError={onError}
        onExpire={onExpire}
        options={{
          theme: 'auto',
          size: 'flexible',
        }}
      />
      {error && (
        <Text size="xs" c="red" mt="xs" fw={500}>
          {error}
        </Text>
      )}
    </Box>
  );
};

export default TurnstileCaptcha;
